import Hotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';
import { CloseBtIcon } from './BookLabTestsUtils';
import CollapseItem, { CollapseItemType } from '../../../common/CollapseItem';

const FAQs: CollapseItemType[] = [
    {
        title: 'Why can I not see the prices for this order?',
        body: 'There may be several reasons why prices are not displayed:',
        content: [
            'Prices for certain medicines may vary based on factors such as location and availability.',
            'While we strive to update prices regularly, there could be instances where the price has changed since the last update.',
        ],
        footer:
            'Rest assured, you can still place an order on behalf of the customer. The final price, including any discounts, will be communicated to the customer at the time of dispatch. Please note that this does not impact the fulfillment process.',
    },
    {
        title: 'Can I still apply the patient discount?',
        body:
            'Absolutely! Any discount you apply will be considered when calculating the final order amount. The patient will receive the discounted price to pay.',
    },
    {
        title: 'How will the customer know when and how much to pay?',
        body:
            'The final price of the medicine will be confirmed with the customer at the time of dispatch. A representative from Eka will call the customer (either the patient or a family member) within a few minutes of placing the order to communicate the final order amount after discount. If the customer is satisfied with the amount, they can confirm the order, and it will be fulfilled accordingly.',
    },
    {
        title: 'Can the customer cancel the order later if they decide not to proceed?',
        body:
            'Yes, the cancellation process remains the same as it is currently. The customer can cancel the order if they wish to do so.',
    },
    {
        title: 'When will I be able to view the final order amount for this order?',
        body:
            'Once the customer confirms the order amount from their end, the price will be updated on the e-pharmacy dashboard under "pending" or "delivered" orders.',
    },
    {
        title: 'Will I receive commission for this order?',
        body:
            'Yes, you will still receive the agreed-upon commission for this order. Your earnings are dependent on the number of orders you successfully place, so if the patient places this order, you will receive the commission as usual.',
    },
];

const UnavailablePriceFAQsModal: React.FC<{
    closeMe: () => void;
}> = ({ closeMe }) => {
    return (
        <Hotkeys keyName="esc">
            <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                style={{ zIndex: 20 }}
                transition={{ duration: 0.2, ease: 'linear' }}
                className="font-lato select-none"
            >
                <div className="modal-overlay" onClick={closeMe}></div>
                <div className="modal-content w-592 max-h-504 h-4/5 font-lato font-400 rounded-8">
                    <div className="h-full flex flex-col" id="unavailable-price-modal">
                        <div className="flex items-center justify-between px-16 py-14 bg-neutral-9 rounded-t-8">
                            <p className="font-700 text-16">ePharmacy</p>
                            <CloseBtIcon closeMe={closeMe} />
                        </div>

                        <div className="flex-1 text-14 px-16 py-14 overflow-auto space-y-4">
                            <p className="font-700">Amount to be paid is not available - FAQs</p>

                            {FAQs.map((item, index) => (
                                <CollapseItem item={item} index={index} />
                            ))}
                        </div>

                        <div className="flex items-center justify-center px-16 py-9 bg-neutral-9 rounded-b-8">
                            <button className="btn--small primary-btn px-16 py-8" onClick={closeMe}>
                                Got it
                            </button>
                        </div>
                    </div>
                </div>
            </motion.div>
        </Hotkeys>
    );
};

export default UnavailablePriceFAQsModal;
